import { GetterTree, Module, MutationTree } from "vuex";
import { RootState } from "../../store.interface";
import { UserStoreState } from "@/shared/interfaces/user/UserStoreState.interface";
import { User } from "@/shared/interfaces/user/User.interface";
import { setDatadogUser, clearDatadogUser } from "@/shared/scripts/datadog";


const state: UserStoreState = {
    user : null
};

const mutations: MutationTree<UserStoreState> = {
    setUser: function(state: UserStoreState, user: User|null) {
        if (user != null) {
            state.user = {
                id: user.id,
                jwtToken: user.jwtToken,
                jwtAdmin: user.jwtAdmin,
                username: user.username,
                email: user.email,
                isAnonymous: user.isAnonymous,
                isMasquerading: user.isMasquerading,
                language: user.language,
            };
            setDatadogUser(state.user);
        } else {
            state.user = null;
            clearDatadogUser();
        }
    }
};

const getters: GetterTree<UserStoreState, RootState> =  {

    /**
     * Only used in scripts (e.g. scripts for API calls) because of TypeScript
     * reasons. Should be removed at a later stage.
     */
    getUser: ((state: UserStoreState): User|null => {
        return state.user;
    }),

    isLogged: (state): boolean => {
        return !!state.user && !state.user.isAnonymous;
    },

    isMasquerading: (state): boolean => {
        return !!state.user && state.user.isMasquerading;
    }
};

const user: Module<UserStoreState, RootState> = {
    namespaced: true,
    state: state,
    mutations: mutations,
    getters: getters
};

export default user;
